import { render, staticRenderFns } from "./BuyNowWithoutPartialBidding.vue?vue&type=template&id=71dd88a8&scoped=true&"
import script from "./BuyNowWithoutPartialBidding.vue?vue&type=script&lang=ts&"
export * from "./BuyNowWithoutPartialBidding.vue?vue&type=script&lang=ts&"
import style0 from "./BuyNowWithoutPartialBidding.vue?vue&type=style&index=0&id=71dd88a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dd88a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
